import React from 'react';
import { Target, Globe, Brain, FileText, TrendingUp, Users } from 'lucide-react';
import { mockData } from '../utils/mock';

const iconMap = {
  target: Target,
  globe: Globe,
  brain: Brain,
  'file-text': FileText,
  'trending-up': TrendingUp,
  users: Users
};

const ServicesSection = ({ id }) => {
  return (
    <section id={id} className="services-section section-container">
      <div className="section-header">
        <h2 className="section-title">Qué es The Keeper Lab</h2>
      </div>

      <div className="services-intro">
        <p className="services-tagline">
          The Keeper Lab es una agencia vertical especializada exclusivamente en porteros y porteras.
        </p>
        
        <div className="services-philosophy">
          <p>No trabajamos por volumen.</p>
          <p className="highlight">Trabajamos por excelencia.</p>
        </div>
      </div>

      <div className="services-grid">
        {mockData.services.map((service, index) => {
          const IconComponent = iconMap[service.icon];
          return (
            <div key={index} className="service-card">
              <div className="service-icon">
                {IconComponent && <IconComponent size={32} />}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          );
        })}
      </div>

      <div className="services-footer">
        <p className="services-conclusion">
          No vendemos promesas.<br />
          <span className="highlight">Construimos trayectorias.</span>
        </p>
      </div>
    </section>
  );
};

export default ServicesSection;
